var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainCard"},[_c('el-page-header',{attrs:{"title":_vm.$t('common.goBack'),"content":null},on:{"back":function($event){return _vm.$router.push({
      name: 'myLeaderDetail',
      params: {
        id: _vm.$route.params.id,
      },
    })}}}),(_vm.pulse.pulse1 || _vm.pulse.pulse2 || _vm.pulse.pulse3)?_c('Pulse',{attrs:{"pulse":_vm.pulse,"pulse-report":_vm.pulseReport,"censor-check":_vm.censorCheck,"show-coworkers":true},on:{"update:pulse":function($event){_vm.pulse=$event}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }